<template>
<span class="catelogs-name" v-show="itemSource.length>1">
    <div>
        <div class="checked-name">
            <div class="list-multnode-name" ref="nodeName" :title="allSource[0].catalog" @click.stop="toCatalog(allSource[0])">
                    <span class="select-categroy-name">{{allSource[0].catalog}}</span>
            </div>
            <div class="icon-util  transfers-more-position" :class="clickShowCurrent == index?'transfer-drop-down-up':'transfer-drop-down'" @click.stop="catelogsSlectShow(index)" v-clickoutside='catelogClose'></div>
            <div class="transfers-from-catelogs" v-show="clickShowCurrent==index" ref="catelogs" :style="{height:(itemSource.length-1)*30+'px'}">
                <el-scrollbar style="height:100%;">
                <div :title="catelogFrom.catalog" class="catelogs" v-for="(catelogFrom, index) in popSource" :key="index" @click.stop="toCatalog(catelogFrom)">{{catelogFrom.catalog}}</div>
                </el-scrollbar>
            </div>
        </div>
    </div>
</span>
</template>

<script>
import "@/assets/css/common_util.css";
import "@/assets/css/file_type.css";
import "@/assets/css/drive_type.css";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    props: ["type", "clickDialogCurrent", "item", "index", 'itemSource'],
    data: function () {
        return {
            clickShowCurrent: this.clickDialogCurrent,
            clickCurrent: '',
            popSource: null,
            popWidth: 0,
            allSource:null
        };
    },
    created() {
        this.allSource=Object.assign([], this.itemSource);
        this.popSource = Object.assign([], this.itemSource);
        this.popSource.splice(0, 1);
    },
    watch:{
          itemSource:{
           immediate:true,
           handler(val){
        this.allSource=Object.assign([], this.itemSource);
        this.popSource = Object.assign([], this.itemSource);
        this.popSource.splice(0, 1);
           }
          }
        
    },
    methods: {
        catelogsSlectShow(index) {
            let catalogLength = [];
            let that = this;
            if (this.clickShowCurrent == index) {
                this.clickShowCurrent = -1;
            } else {
                this.$nextTick(function () {
                    that.popWidth = that.$refs.nodeName.offsetWidth;
                });
                $.each(this.popSource, function (index, item) {
                    catalogLength.push(item.catalog.length);
                });
                //sort排序算法
                function new_sort(val1,val2){
                    if(val1<val2){
                        return -1
                    }else if(val1>val2){
                        return 1
                    }else{
                        return 0
                    }
                }
                catalogLength = catalogLength.sort(new_sort);
                //获取select外的基本长度
                let rootCatalogLength = that.$refs.nodeName.title.length;
                //内部有更长的，长度小于32则自适应，大于32则固定245，否则以外部长度+6
                if ((catalogLength[catalogLength.length - 1] > rootCatalogLength) && catalogLength[catalogLength.length - 1] <= 32) {
                    // that.$nextTick(function () {
                    //     that.popWidth = catalogLength[catalogLength.length - 1] * 6;
                    //     that.$refs.catelogs.style.width = '100%';
                    // });
                }else if((catalogLength[catalogLength.length - 1] > rootCatalogLength) && catalogLength[catalogLength.length - 1] > 32){
                    that.$nextTick(function () {
                        that.popWidth = 245;
                        that.$refs.catelogs.style.width = that.popWidth+'Px';
                    });
                }else if(catalogLength[catalogLength.length - 1] <= rootCatalogLength){
                    that.$nextTick(function () {
                        that.popWidth = that.$refs.nodeName.offsetWidth;
                        that.$refs.catelogs.style.width = that.popWidth+6+'Px';
                    });
                }
                this.clickShowCurrent = index;
            }
        },
        catelogClose() {
            this.clickShowCurrent = -1;
        },
        toCatalog(data) {
            if (this.type == 1) {
                if(this.itemSource[0].isShare){
                    window.open(this.itemSource[0].shareUrl)
                }else
                if (data.fromItem) {
                    //传输的打开源目录，打开并选中
                    this.$parent.toSourceCatalog(data.fromItem);
                } else if (data.toItem) {
                    //直接打开该目录
                    this.$parent.toAimCatalog(data.toItem);
                }
            } else { //直接打开该目录
                if (data.fromItem) {
                    this.$parent.toAimCatalog(data.fromItem);
                } else if (data.toItem) {
                    this.$parent.toAimCatalog(data.toItem);
                }

            }
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 26) {
                return value.slice(0, 26) + '...';
            }
            return value;
        },
        ellipsisDialog(value) {
            if (!value) return '';
            if (value.length > 32) {
                return value.slice(0, 32) + '...';
            }
            return value;
        }
    }
};
</script>

<style scoped>
.catelogs-name {
    width: 80px;
    /*no*/
    height: 20px;
    /*no*/
    float: left;
}

.checked-name {
    float: left;
    position: relative;
    width: 280px;
    /*no*/
}

.checked-name:hover {
    text-decoration: underline;
    cursor: pointer;
}

.transfers-more-position {
    float: left;
    position: relative;
    top: -6px;
    /*no*/
}

.transfers-from-catelogs {
    position: absolute;
    z-index: 3;
    border: 1px solid #8a96e3;
    /*no*/
    top: 18px;
    /*no*/
    background: #fff !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-height: 350Px !important;
}

.catelogs {
    height: 30px;
    /*no*/
    background: #fff;
    text-align: left;
    line-height: 30px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.catelogs:hover {
    background: #d9e7ff;
    color: #4281ff;
    text-decoration: underline;
    cursor: pointer;
}

.catelogs-click {
    background: #d9e7ff;
    color: #4281ff;
}

.list-multnode-name {
    max-width: 225Px;
    color: #4281ff;
    height: 20px !important;
    /*no*/
    float: left;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}

.list-multnode-name:hover {
    text-decoration: underline;
    cursor: pointer;
}

.select-categroy-name:hover {
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/common/select/task_list_select.vue